<div class="story-modal-wrapper">
  <mat-dialog-content>
    <div>
      <button class="cmn-close" (click)="onNoClick()"></button>
      <div class="imageWrapper">
        <img
          [src]="
            data.thumbURL || '../../../assets/images/placeHolderImage.jpg'
          "
          alt="StoryImage"
        />
      </div>
      <div class="content-wrapper">
        <p>{{ getDescription(data)}}</p>
      </div>
    </div>
  </mat-dialog-content>
</div>
